/* Progressive enhancement: no click interception, dependency or animation loop. */
if (!customElements.get('monument-collection-scene')) {
  customElements.define('monument-collection-scene', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      this.motion = matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      this.reset = () => {
        cancelAnimationFrame(this.frame);
        ['rx', 'ry', 'x', 'y', 'tx', 'ty'].forEach(key => this.style.removeProperty(`--scene-${key}`));
      };
      this.addEventListener('pointermove', event => {
        if (!this.motion.matches || event.pointerType === 'touch') return;
        const rect = this.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, (event.clientX - rect.left) / rect.width * 2 - 1));
        const y = Math.max(-1, Math.min(1, (event.clientY - rect.top) / rect.height * 2 - 1));
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.style.setProperty('--scene-rx', `${-y * 3.5}deg`);
          this.style.setProperty('--scene-ry', `${x * 4}deg`);
          this.style.setProperty('--scene-x', `${-x * 5}px`);
          this.style.setProperty('--scene-y', `${-y * 5}px`);
          this.style.setProperty('--scene-tx', `${x * 2}px`);
          this.style.setProperty('--scene-ty', `${y * 2}px`);
        });
      }, options);
      this.addEventListener('pointerleave', this.reset, options);
      this.addEventListener('pointercancel', this.reset, options);
      this.addEventListener('focusin', this.reset, options);
      this.motion.addEventListener('change', this.reset, options);
    }
    disconnectedCallback() {
      this.reset?.();
      this.cleanup?.abort();
    }
  });
}
